export var Tier;
(function (Tier) {
    Tier["Free"] = "Free";
    Tier["Pro"] = "Pro";
    Tier["Business"] = "Business";
})(Tier || (Tier = {}));
//# sourceMappingURL=tier.const.js.map